export default __webpack_public_path__ + "static/media/close_icon.ccc4d7b2.svg";